
import { defineComponent, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { MenuComponent } from "@/assets/ts/components";
import { getConfigs, setConfigs } from "@/core/services/AppService";
import nestedDraggable from "./nested.vue";
export default defineComponent({
  name: "menu-component",
  components: {
    nestedDraggable,
  },
  setup() {
    const store = useStore();
    const key = "menu_data";
    const loading = ref<boolean>(false);
    let objectData = ref({
      main_menu: [],
    });
    const menuItems = ref<any[]>(objectData.value.main_menu);
    onMounted(async () => {
      setCurrentPageBreadcrumbs("Cấu hình Website", ["Cấu hình"]);
      MenuComponent.reinitialization();
      await getConfigs(key).then((data) => {
        if (typeof data === "object") {
          objectData.value = { ...objectData.value, ...data };
          menuItems.value = objectData.value.main_menu;
        }
      });
      // setConfigs({key:"home_config",value:objectData.value})
    });
    const addMenuItem = () => {
      menuItems.value.push({
        name: "Tên menu",
        url: "#",
        id: 0,
        children: [],
      });
    };
    const removeMenuItem = (index) => {
      menuItems.value.splice(index, 1);
    };
    const formRef = ref<null | HTMLFormElement>(null);
    const submit = () => {
      setConfigs({ key, value: objectData.value })
        .then(() => {
          Swal.fire({
            text: "Cập nhật thông menu thành công",
            icon: "success",
            buttonsStyling: false,
            showConfirmButton: false,
            timer: 1000,
          });
        })
        .catch(() => {
          Swal.fire({
            text: store.getters.getErrors,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Thử lại!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        });
    };
    return {
      submit,
      loading,
      objectData,
      addMenuItem,
      removeMenuItem,
      menuItems,
    };
  },
});
